
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMe"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"acceptsNewsletter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companySiret"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isCoveredByOrganizationSubscription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sector"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAdmin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isStaff"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isImpersonator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canManageUser"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canManagePlaylist"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canManageAlbum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canManageBrief"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canDownload"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canAccessSoundEffects"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasStreamingFeature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canRequestLicence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canDownloadWithWatermark"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isInAllowedCountry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displaySubscriptionBanner"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"hubspotConversationToken"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startsAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextOccurrenceAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"finishesAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manageUrl"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":764}};
    doc.loc.source = {"body":"query GetMe {\n  me {\n    id\n    email\n    firstName\n    lastName\n    country\n    phoneNumber\n    acceptsNewsletter\n    type\n    companyName\n    companySiret\n    organization {\n        name\n    }\n    isCoveredByOrganizationSubscription\n    job\n    sector\n    permissions {\n      isAdmin\n      isStaff\n      isImpersonator\n      canManageUser\n      canManagePlaylist\n      canManageAlbum\n      canManageBrief\n      canDownload\n      canAccessSoundEffects\n      hasStreamingFeature\n      canRequestLicence\n      canDownloadWithWatermark\n      isInAllowedCountry\n      displaySubscriptionBanner\n    }\n    hubspotConversationToken\n    subscription {\n        name\n        status\n        startsAt\n        nextOccurrenceAt\n        finishesAt\n        manageUrl\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetMe"] = oneQuery(doc, "GetMe");
        
